<template>
    <div style="background: #ffffff;padding-top:30px">
        <!--  便签 -->
        <div class="container slogan">
            <div class="item">
                <div class="img">
                    <img src="../assets/quan.png" />
                </div>
                <div class="word">产品齐全</div>
            </div>

            <div class="item">
                <div class="img">
                    <img src="../assets/kuai.png" />
                </div>
                <div class="word">现货率高</div>
            </div>

            <div class="item">
                <div class="img">
                    <img src="../assets/zhi.png" />
                </div>
                <div class="word">质量保证</div>
            </div>

            <div class="item">
                <div class="img">
                    <img src="../assets/tui.png" />
                </div>
                <div class="word">售后无忧</div>
            </div>
        </div>
        <div class="footer">
            <div data-v-5d863138 class="footertext">
                <div style="display: flex;justify-content: center;align-items: center;">
                    <div>联系人：白健 联系QQ：1330005320</div>
                    <a
                        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37131202371613"
                        target="_blank"
                        style="color: #333333;"
                    >
                        <div style="margin-left:50px">
                            <img src="../assets/beian.png" />鲁公网安备37131202371613
                        </div>
                    </a>
                </div>
                Copyright© 捷采云化玻 版权所有 2021-2026，All Rights Reserved <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#333333"
                    >鲁ICP备16034461号-2</a>
                <br />
                <span style="color:red"
                    >本网站销售的所有产品仅用于工业应用或者科学研究等非医疗目的，不可用于人类或动物的临床诊断或治疗，非药用，非食用。</span
                >
                <!-- <br />技术支持：南京杰锋网络科技有限公司 -->
            </div>
        </div>
    </div>
</template>

<script>
// import * as apis from '../fetch/common';

export default {
    name: 'v-footer',
    data() {
        return {
            categoryList: [],
        };
    },
    methods: {
        toItem(val) {
            if (val.code === 'product_catalog_download') {
                this.$router.push('/proindex');
            } else if (val.code === 'technical_information') {
                this.$router.push('/news-list');
            } else if (val.code === 'customized_synthesis') {
                this.$router.push('/promade');
            } else if (val.code === 'quality_certificate_coa') {
                this.$router.push('/coa');
            } else {
                this.$router.push('/introduce/' + val.code);
            }
        },
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.footer {
    width: 100%;
    padding-bottom: 20px;
    .container {
        width: 1100px;
        display: flex;
        justify-content: space-between;
        .item {
            margin-top: -25px;
            .title {
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-size: 14px;
                color: #727272;
                position: relative;
            }
            .title::before {
                content: '';
                border-right: 20px solid #f1f1f1;
                border-top: 20px solid transparent;
                border-bottom: 20px solid transparent;
                position: absolute;
                top: 0;
                left: -20px;
            }
            .title::after {
                content: '';
                border-left: 20px solid #f1f1f1;
                border-top: 20px solid transparent;
                border-bottom: 20px solid transparent;
                position: absolute;
                top: 0;
                right: -20px;
            }
            .link {
                padding-left: 0;
                li {
                    font-size: 12px;
                    line-height: 40px;
                    text-align: center;
                    list-style: none;
                    color: #333333;
                    cursor: pointer;
                }
            }
        }
    }

    .footertext {
        text-align: center;
        color: #333333;
        font-size: 12px;
        line-height: 25px;
    }
}

.slogan {
    height: 100px;
    display: flex;
    .item {
        text-align: center;
        flex: 1;
        img {
            width: 30px;
        }
        .word {
            color: #3b3f4d;
            font-size: 12px;
            line-height: 20px;
        }
    }
}
</style>
